export default __webpack_public_path__ + "static/media/account-module-icon.21492f0a.svg";